import { DeliveryPolicy, Money, } from "../../ordering";
import { localizePath } from "../../locale";
/**
 * Service for checking goegraphical information about the order, such as if the restaurant deliver to an address.
 */
export class GeocodingService {
    constructor(params) {
        this.rpcService = params.rpcService;
        this.siteId = params.siteId;
    }
    /**
     * @returns does the restaurant deliver to the provided address, how much will the delivery cost, how far away is the restaruant from the provided address
     */
    async getAddressInfo(restaurantId, address, source) {
        const response = await this.rpcService.rpc("GetAddressInfoRequest", {
            address,
            restaurantId: restaurantId.value,
            source: source,
        });
        return {
            coordinates: response.coordinates,
            distance: response.distance,
            deliveryInfo: response.deliveryInfo !== null
                ? {
                    zoneName: response.deliveryInfo.zoneName,
                    averageTime: response.deliveryInfo.averageTime,
                    distance: response.deliveryInfo.distance,
                    deliveryCost: Money.fromBackend(response.deliveryInfo.deliveryCost),
                    minOrderValue: Money.fromBackend(response.deliveryInfo.minOrderValue),
                    freeDeliveryThreshold: response.deliveryInfo.freeDeliveryThreshold === null
                        ? null
                        : Money.fromBackend(response.deliveryInfo.freeDeliveryThreshold),
                }
                : null,
        };
    }
    async geocode(country, address) {
        const result = await this.rpcService.rpc("GeocodeRequest", {
            streetAddress: address,
            country,
            accountId: null,
            restaurantId: null,
            fromPS: true,
        });
        return result.coordinates;
    }
    async getDeliveryAddressStatus(restaurantId, streetAddress) {
        if (streetAddress.availability.isAvailable.isDefinitelyFalse) {
            return { type: "NoAddressProvided" };
        }
        const coordinates = await this.geocode(streetAddress.country, streetAddress.checkoutData);
        if (coordinates === null) {
            return { type: "AddressDoesNotExistOrInaccurate" };
        }
        else if ("error" in coordinates) {
            return { type: "NetworkError" };
        }
        const allRestaurants = await this.rpcService.rpc("GetRestaurants", {
            siteId: this.siteId,
            location: coordinates,
        });
        const deliveringRestaurants = allRestaurants.filter((r) => r.deliveryInfo !== null);
        if (deliveringRestaurants.length === 0) {
            return {
                type: "RestaurantDoesntDeliverTo",
                streetAddress,
                coordinates,
            };
        }
        const currentRestaurant = deliveringRestaurants.find((r) => r.id === restaurantId.value);
        if (currentRestaurant === undefined) {
            const restaurant = deliveringRestaurants[0];
            return {
                type: "ChangeRestaurant",
                restaurantInfo: {
                    name: restaurant.name,
                    path: localizePath(`/restauracja/${restaurant.slug}`),
                },
                coordinates,
            };
        }
        const { deliveryCost, minOrderValue } = currentRestaurant.deliveryInfo;
        return {
            type: "RestaurantDelivers",
            deliveryCost: Money.fromBackend(deliveryCost),
            minOrderValue: Money.fromBackend(minOrderValue),
            coordinates,
        };
    }
    async getDeliveryPolicy(restaurantId, address) {
        if (address === null ||
            address.city.length === 0 ||
            address.street.length === 0 ||
            address.streetNumber.length === 0) {
            return DeliveryPolicy.Impossible;
        }
        const { deliveryInfo } = await this.getAddressInfo(restaurantId, address, 
        // For now it's only used for checking address inside cart and checkout
        // Parameterize if it starts being used in other contexts as well
        "SitesCartCheckout");
        if (deliveryInfo === null) {
            return DeliveryPolicy.Impossible;
        }
        return DeliveryPolicy.paid({
            cost: deliveryInfo.deliveryCost,
            freeDeliveryThreshold: deliveryInfo.freeDeliveryThreshold,
            minOrderValue: deliveryInfo.minOrderValue,
        });
    }
    async reverseGeocode(restaurantId, coordinates) {
        var _a;
        const response = await this.rpcService.rpc("ReverseGeocodeRequest", {
            coordinates,
            restaurantId: (_a = restaurantId === null || restaurantId === void 0 ? void 0 : restaurantId.value) !== null && _a !== void 0 ? _a : null,
        });
        return response.streetAddress;
    }
}
